import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";
import Input from "../form/Input";
import Button from "../form/Button";
import { postData } from "../../services/api";
import toastr from "toastr";
import { classNames } from "../../helper/classNames";

import OtherPositionPopup from "./OtherPositionPopup";
import Select from "../form/Select";

const AddEditBoardmember = ({
  isOpen,
  setIsOpen = () => {},
  data,
  loadList = () => {},
}) => {
  const { t } = useTranslation();
  const [position, setPosition] = useState([]);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [loading, setLoading] = useState(false);
  const [designation, setDesignation] = useState("");
  const [positionType, setPositionType] = useState(0);
  const [enabledOtherPositionPopup, setEnabledOtherPositionPopup] =
    useState(false);
  const [actionValue, setActionValue] = useState({});
  const [detailsId, setDetailsId] = useState("");

  const closeModal = () => {
    setIsOpen({ data: null, open: false });
    setFirstName("");
    setLastName("");
    setDesignation("");
  };

  useEffect(() => {
    if (actionValue) {
      setPosition([...position, actionValue]);
      if (positionType && positionType === 1) {
        setDesignation(actionValue?._id);
      }

      setPositionType(0);
    }
  }, [actionValue]);

  useEffect(() => {
    setFirstName(data?.first_name);
    setLastName(data?.last_name);
    setDetailsId(data?._id);
    setDesignation(data?.position);
  }, [data]);

  useEffect(() => {
    async function positionData() {
      try {
        const result = await postData("position/list", {
          sortQuery: { ordering: 1 },
          isBoardMember: 1,
          status: 1,
        });
        if (result.data) {
          setPosition(result.data);
        } else {
          console.log("Position list message", result.message);
        }
      } catch (error) {
        console.log("Error position list catch", error.message);
      }
    }
    positionData();
  }, []);

  const onSubmit = async (e) => {
    setLoading(true);
    try {
      let path;
      let payload;
      if (detailsId) {
        path = "board-member/update-field";
        payload = {
          id: detailsId,
          first_name: firstName,
          last_name: lastName,
          position: designation !== "others" ? designation : null,
        };
      }
      const result = await postData(path, payload);
      if (result.status && result.status === 200) {
        toastr.success(result.message);
        setLoading(false);
        setIsOpen({ data: null, open: false });
        loadList();
        closeModal();
      } else {
        toastr.error(result.message);
        setLoading(false);
      }
    } catch (error) {
      toastr.error(error.message);
      setLoading(false);
    }
  };

  return (
    <>
      <div className="relative z-50 overflow-hidden w-full">
        <div
          className={classNames(
            "fixed inset-0 bg-black bg-opacity-25 transition-all duration-300",
            isOpen ? "opacity-100 visible" : "opacity-0 invisible"
          )}
        />
        <div
          className={classNames(
            "fixed inset-0 overflow-y-auto transition-transform duration-300",
            isOpen ? "opacity-100 visible" : "opacity-0 invisible"
          )}
        >
          <div className="flex h-screen justify-end w-full overflow-hidden">
            <div
              className={classNames(
                "w-full flex flex-col max-w-xl rounded-l-2xl p-4 bg-white text-left align-middle shadow-xl transition-all duration-300",
                isOpen ? "translate-x-0" : "translate-x-full"
              )}
            >
              <div className="relative flex-shrink-0">
                <h3 className="text-lg font-medium leading-6 text-gray-900 text-center mb-4">
                  {data?._id ? "Edit Board Member" : "Add Boardmember"}
                </h3>
                <div className="absolute -top-4 -right-4 z-10">
                  <Button
                    buttonLabelClasses=""
                    buttonType={"button"}
                    buttonIcon={"fa-light fa-times"}
                    buttonIconPosition={"left"}
                    buttonLabel={""}
                    buttonClasses={
                      "!bg-transparent !text-slate-700 !w-10 !h-10 !p-0"
                    }
                    functions={() => {
                      closeModal();
                    }}
                    buttonHasLink={false}
                  />
                </div>
              </div>
              <div className="relative mt-4">
                <div className="grid grid-cols-12 gap-4">
                  <div className="col-span-12 flex flex-col">
                    <div className="space-y-4">
                      <div className="grid grid-cols-1 gap-4">
                        <div className="relative w-full">
                          <Input
                            label={"First Name"}
                            labelClasses={"!text-xs"}
                            inputType={"text"}
                            inputPlaceholder={"Enter First Name"}
                            inputValue={firstName}
                            setInput={setFirstName}
                            requiredDisplay={true}
                          />
                        </div>
                      </div>
                      <div className="grid grid-cols-1 gap-4">
                        <div className="relative w-full">
                          <Input
                            label={"Last Name"}
                            labelClasses={"!text-xs"}
                            inputType={"text"}
                            inputPlaceholder={"Enter Last Name"}
                            inputValue={lastName}
                            setInput={setLastName}
                            requiredDisplay={true}
                          />
                        </div>
                      </div>
                      {/* <div className="grid grid-cols-1 gap-4">
                        <div className="relative w-full">
                          <Input
                            label={"Emails"}
                            requiredDisplay={true}
                            labelClasses={"!text-xs"}
                            inputType={"text"}
                            inputPlaceholder={"Enter Email"}
                            inputValue={email}
                            setInput={setEmail}
                            is
                          />
                        </div>
                      </div> */}
                      <div className="grid grid-cols-1 gap-4">
                        <div className="relative w-full">
                          <Select
                            label={t("current_board_position_held")}
                            labelClasses={"!text-xs !font-semibold"}
                            xPlacement={"left"}
                            selectedValue={designation}
                            dropdownClass={"!w-full"}
                            dropdownData={[
                              {
                                _id: " ",
                                label: t("select_position"),
                                value: "",
                              },
                              ...position.map((item) => ({
                                _id: item?._id,
                                label: item?.name,
                                value: item?._id,
                              })),
                              {
                                _id: "others",
                                label: t("other"),
                                value: "others",
                              },
                            ].filter((itm) => itm)}
                            getSelectedValue={(e) => {
                              if (e._id === "others") {
                                setEnabledOtherPositionPopup(true);
                                setPositionType(1);
                              }
                              setDesignation(e._id);
                            }}
                            requiredDisplay={true}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="flex justify-center gap-4 mt-8">
                      <div className="flex items-center justify-center gap-4">
                        <Button
                          buttonClasses={
                            "bg-white border border-slate-200 !text-slate-400 ml-2"
                          }
                          buttonLabelClasses=""
                          buttonType={"button"}
                          buttonIcon={"fa-regular fa-xmark"}
                          buttonIconPosition={"left"}
                          buttonLabel={t("cancel")}
                          functions={() => {
                            closeModal();
                          }}
                          buttonHasLink={false}
                        />
                        <Button
                          buttonClasses=""
                          buttonLabelClasses=""
                          buttonType={"button"}
                          buttonIcon={
                            loading
                              ? "fa-light fa-spinner fa-spin"
                              : "fa-light fa-check"
                          }
                          buttonIconPosition={"left"}
                          buttonLabel={t("save")}
                          functions={onSubmit}
                          buttonHasLink={false}
                          buttonDisabled={loading}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {enabledOtherPositionPopup && (
        <OtherPositionPopup
          isOpen={enabledOtherPositionPopup}
          setIsOpen={(val) => setEnabledOtherPositionPopup(val)}
          getActionValue={(obj) => {
            setActionValue(obj);
          }}
          data={{ isBoardMember: 1 }}
        />
      )}
    </>
  );
};

export default AddEditBoardmember;
